import React from 'react';
import styles from './EmptyState.module.css';

/**
 * Empty / no-results / panel-empty / error state, per the app patterns
 * handoff. `size`: 'page' fills the list area (min 400px tall); 'panel' sits
 * inside a side panel. `tone`: 'error' tints the icon only, never the card.
 * `large` bumps the title to 26px on desktop (the "first use" case) - every
 * other case, and all of mobile, stays at 22px. `assertive`: use role="alert"
 * for an error that appears after a user action (e.g. a retry that also
 * failed); a first-load error stays the aria-live="polite" default.
 */
const EmptyState = ({illustration, title, description, primaryAction, secondaryAction, size = 'page', tone = 'neutral', large, assertive}) => (
    <div
        className={`${styles.root} ${styles[size]} ${tone === 'error' ? styles.error : ''}`}
        role={tone === 'error' && assertive ? 'alert' : undefined}
        aria-live={tone === 'error' && assertive ? undefined : 'polite'}
    >
        {illustration}
        <h3 className={`${styles.title} ${large ? styles.large : ''}`}>{title}</h3>
        {description && <p className={styles.description}>{description}</p>}
        {(primaryAction || secondaryAction) && (
            <div className={styles.actions}>
                {primaryAction}
                {secondaryAction}
            </div>
        )}
    </div>
);

export default EmptyState;
